import { render, staticRenderFns } from "./order3.vue?vue&type=template&id=3449166e&"
import script from "./order3.vue?vue&type=script&lang=js&"
export * from "./order3.vue?vue&type=script&lang=js&"
import style0 from "./order3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports